import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';

function Introduction(props) {
  return (
    <CSSTransitionGroup
    className="container"
    component="div"
    transitionName="fade"
    transitionEnterTimeout={2000}
    transitionLeaveTimeout={1500}
    transitionAppear
    transitionAppearTimeout={1500}
    >
    <div className="introduction-background">
        <div className="container introduction-container">
            <div className="row">
                <div className="col-md-6">
                    <h1 className="introduction-heading">
                        Find Your<br/>Foundation Shade
                    </h1>
                    <p className="introduction-desc">
                        Not sure which foundation shade is right for you?<br/><br/>Discover the perfect foundation that complements your skin type now, plus Bovanti Beauty essentials hand‑picked for your skin tone.
                    </p>
                </div>
                <div className="col-md-6 button-introduction-vertical-center">
                    <a onClick={props.onContinueSelected}>
                        <span className="button is-primary">
                            Take Quiz Now
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
    </CSSTransitionGroup>
  );
}

Introduction.propTypes = {
    onContinueSelected: PropTypes.func.isRequired
};

export default Introduction;